import { getCurrentUser } from '@/lib/stores/unifiedUserStore';
import { platformTranslations, TranslationKey } from '@/lib/translations/platformTranslations';

export function usePlatformTranslation() {
  try {
    // Safely get current user, handling cases where store is not yet initialized
    let currentUser;
    try {
      currentUser = getCurrentUser();
    } catch (error) {
      console.warn('usePlatformTranslation: Could not get current user, using default language', error);
      currentUser = null;
    }
    
    // Safely access settings with multiple fallbacks
    const userLanguage = currentUser?.settings?.language || 'en';

    const t = (key: TranslationKey, fallback?: string): string => {
      try {
        const translations = platformTranslations[key];
        if (!translations) return fallback || key;
        
        // Try user's language first, then 'en', then fallback, then key
        return translations[userLanguage as keyof typeof translations] || 
               translations['en' as keyof typeof translations] || 
               fallback || 
               key;
      } catch (error) {
        console.error('Error in translation function:', error);
        return fallback || key;
      }
    };

    return { t };
  } catch (error) {
    console.error('Critical error in usePlatformTranslation hook:', error);
    // Return a safe fallback function that always returns the key or fallback
    return {
      t: (key: TranslationKey, fallback?: string): string => {
        return fallback || key;
      }
    };
  }
}